import axios from "axios";
import config from "../../../config.json"; 

/**
 * Получаем данные дешборда по /api/dashboard/data.
 * @param {Object} params - { start, end }
 * @returns {Promise<Object>} JSON-объект с полями:
 * { requestsData, clientsToday, clientsMonth, averageAge, averageCheck, managerData,
 * overallData, distributionData, durationData, managers, genderDistribution, geographyDistribution, bestSelling }
 */
export const fetchDashboardData = async (params) => {
  const response = await axios.get(`${config.service}/api/dashboard/data`, {
    params,
    headers: {
      "Cache-Control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`
    }
  });
  return response.data;
};
